// extracted by mini-css-extract-plugin
module.exports = {"page_title":"OrderSummaryPage_page_title__4mjXg","orders_summary":"OrderSummaryPage_orders_summary__3MLJL"};